export default __webpack_public_path__ + "static/storyjohnny-93da5ca51aec03bb618374bcf7e458cd.jpg";